import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import {
  selectConfiguracionDePago,
  selectError,
  selectEstadoDePagoLoaded,
  selectIdPago,
  selectPago,
  selectUrlRedirectOtroMedioDePago,
} from 'src/app/store/selectors/pago.select';
import { AppState } from 'src/app/store/state/app.state';
import { ConfiguracionDePago } from 'src/app/pago/models/ConfiguracionDePago.model';
import { Pago } from 'src/app/pago/models/Pago.model';
import { ErrorPago } from 'src/app/pago/models/ErrorPago.model';
import { filter, take } from 'rxjs/operators';
import { BaseFacade } from 'src/app/pago/services/base-facade/BaseFacade';

@Injectable({
  providedIn: 'root',
})
export class PagoFacade extends BaseFacade {
  configuracionDePago$: Observable<ConfiguracionDePago>;
  pago$: Observable<Pago>;
  idPago$: Observable<string>;
  error$: Observable<ErrorPago>;
  urlRedirectOtroMedioDePago$: Observable<string>;
  estadoDePagoLoaded$: Observable<boolean>;

  constructor(protected store: Store<AppState>) {
    super(store);
    this.configuracionDePago$ = this.store.pipe(
      select(selectConfiguracionDePago),
      filter(
        (configuracionDePago: ConfiguracionDePago) =>
          !!configuracionDePago.idProducto
      ),
      take(1)
    );

    this.pago$ = this.store.pipe(
      select(selectPago),
      filter((pago: Pago) => !!pago.idProducto)
    );

    this.idPago$ = this.store.pipe(
      select(selectIdPago),
      filter((idPago: string) => !!idPago),
      take(1)
    );

    this.urlRedirectOtroMedioDePago$ = this.store.pipe(
      select(selectUrlRedirectOtroMedioDePago),
      filter(
        (urlRedirectOtroMedioDePago: string) => !!urlRedirectOtroMedioDePago
      ),
      take(1)
    );

    this.error$ = this.store.pipe(select(selectError));

    this.estadoDePagoLoaded$ = this.store.pipe(
      select(selectEstadoDePagoLoaded)
    );
  }
}
